import { FloatingHeader } from '@lmig/lmds-react-floating-header';
import { getSettingsUIUrl } from 'Foundation/Configurations/GlobalConfiguration';
import { useEffect } from 'react';
import { Content } from '@lmig/lmds-react-content';
import './Settings.scss';
import PageFooter from 'Feature/Chrome/Footer/PageFooter';

export default function Settings() {
  useEffect(() => {
    document.title = 'Settings';
    window.addEventListener('message', onMessage);
  }, []);

  const onMessage = (message: MessageEvent) => {
    if (message && message.data) {
      let obj = JSON.parse(message.data);
      if (obj.command == 'InitResizer') (window as any).iFrameResize({ log: true }, '#iSettings');
    }
  };

  return (
    <div id="safeco-settings-page">
      <FloatingHeader brand="liberty" isFullWidth={true} hideDivider={true} appName={'Settings'} brandLinkProps={{ href: '/start' }} />
      <Content>
        <iframe id="iSettings" src={getSettingsUIUrl()} style={{ width: '1px', minWidth: '100%' }} />
      </Content>
      <PageFooter />
    </div>
  );
}
